import axios from "../utils/axios";

/**
 * Get program invoice
 */
export const getProgramInvoice = async (programId) => {
    const response = await axios.get(`/programs/${programId}/invoice`);
    return response.data;
};

/**
 * Get all invoices
 */
export const getAllInvoices = async (page = 1, limit = 10, search = '', type = '', status = '') => {
    const response = await axios.get('/invoices', {
        params: {
            page,
            limit,
            search,
            type,
            status,
        }
    });
    return response.data;
};

/**
 * Get invoice by id
 */
export const getInvoice = async (id) => {
    const response = await axios.get(`/invoices/${id}`);
    return response.data;
};

/**
 * Create invoice for a program
 */
export const createProgramInvoice = async (programId, data) => {
    const response = await axios.post(`/programs/${programId}/invoice`, data);
    return response.data;
};

/**
 * Update invoice
 */
export const updateInvoice = async (data, id) => {
    const response = await axios.put(`/invoices/${id}`, data);
    return response.data;
};

/**
 * Delete invoice (soft delete)
 */
export const deleteInvoice = async (id) => {
    const response = await axios.delete(`/invoices/${id}`);
    return response.data;
};

/**
 * Restore invoice
 */
export const restoreInvoice = async (id) => {
    const response = await axios.post(`/invoices/${id}/restore`);
    return response.data;
};

/**
 * Force delete invoice
 */
export const forceDeleteInvoice = async (id) => {
    const response = await axios.delete(`/invoices/${id}/force-delete`);
    return response.data;
};

/**
 * Export invoice to PDF
 */
export const exportInvoiceToPdf = async (id, data) => {
    const response = await axios.post(`/invoices/${id}/export-pdf`, data, {
        responseType: 'blob'
    });
    return response;
};

/**
 * Convert invoice currency
 */
export const convertInvoiceCurrency = async (id, currencyId) => {
    const response = await axios.post(`/invoices/${id}/convert-currency`, {
        currency_id: currencyId
    });
    return response.data;
};
